// extracted by mini-css-extract-plugin
module.exports = {"imageWrapper":"background-image-module--image-wrapper--ULkuz"};